<div class="flex flex-row">

  <div class="flex flex-col grow">

    <ng-content></ng-content>

  </div>

  <div class="flex flex-row justify-center items-center mb-[20px]">
    
    <button type="button"
      (click)="openDialog()"
      mat-icon-button><mat-icon>contacts</mat-icon></button>

  </div>

</div>
